@if (issuesWithDetails() && issuesWithDetails().length > 0) {

  <div class="needs-attention-tab"
       data-testid="needs-attention-list">
    <p class="title">Your current list of Needs Attention Items:</p>
    @for (issueWithDetails of issuesWithDetails(); track issueWithDetails.issue.id) {
      <needs-attention-item [issueWithDetail]="issueWithDetails"
                            (navToIssue)="navToIssue($event)" />
    }
  </div>
}
@else {
  <div class="needs-attention-tab-empty"
       data-testid="needs-attention-container-empty">
    <img class="back-arrow"
         src="assets/icons/folder-open.svg"
         alt="Needs Attention" />
    <div class="empty-container">
      <p class="empty-title">No Items Reported!</p>
      <p class="empty-content">All items marked as 'Needs Attention' will show up here.</p>
    </div>
  </div>
}